<template>
  <div>
    <form method="post"
          data-vv-scope="enlazar"
    >
      <b-row style="justify-content: center;font-size:15pt; text-align:center">
        Por favor seleccione el padre de la ubicación <br>
        para realizar el enlace en el árbol de ubicaciones
      </b-row>
      <b-row class="mt-4"
             style="justify-content: center"
      >
        <b-col sm="3">
          <b-form-group>
            <label for="id_nivel">Ubicación Padre</label><br/>
            <el-select id="padre"
                       name="padre"
                       :options="ubicacionEmpresa"
                       @change="verUbicacionPadre(ubicacionEmpresa[ubicacionParent.id])"
                       v-model="ubicacionParent.id"
                       data-vv-as=" "
                       v-validate="'required'"
            >
              <el-option v-for="ubicacion in ubicacionEmpresa"
                         :label="ubicacion.text"
                         :value="ubicacion.value"
                         :key="ubicacion.value"
              />
            </el-select>
            <span class="text-danger span-error small">
                      {{ errors.first('enlazar.padre') }}
                    </span>
          </b-form-group>
        </b-col>
      </b-row>
    </form>
    <b-row class="mt-3">
      <b-col>
        <button class="btn btn-secondary float-left"
                @click="setPaso(0)"
        >Anterior
        </button>
        <button class="btn btn-primary float-right"
                @click="finalizar()"
        >Finalizar
        </button>
        <button class="btn btn-secondary float-right mr-2"
                @click="cancelar"
        >Cancelar
        </button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue';

import VeeValidate, {Validator} from 'vee-validate';
import es from 'vee-validate/dist/locale/es';

Vue.use(VeeValidate, {
  fieldsBagName: 'vvFields',
  events: 'change',
});

Validator.localize('es', es);
import {
  mapState,
  mapActions,
  mapMutations
} from 'vuex';
import Swal from 'sweetalert2';

export default {
  data() {
    return {};
  },
  props: {
    asociar: {
      default: false,
      type: Boolean
    }
  },
  methods: {
    async finalizar() {
      this.$validator.validateAll('enlazar').then(async (result) => {
        if (result) {
          if (!this.asociar) {
            await this.crearUbicacion();
            this.resetSelectedUbicacion();
          }
          await this.crearUbicacionEmpresa();
          this.setModal(false);
          this.resetSelectedUbicacionEmpresa();
          this.resetSelectedUbicacion();
          await this.arbolUbicacionesEmpresa();
          this.resetOptions();
          this.setPaso(0);
        }
      });
    },
    async verUbicacionPadre(query) {
      this.load(true);
      this.setIdUbicacionParent(query);
      await this.verUbicacionesEmpresa(this.$route.params.id);
      if (this.selectedUbicacionEmpresa.id_parent == '') {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'La ubicación no existe como ubicación padre, por favor seleccione otro o activelo',
          showConfirmButton: true,
          timer: 5000
        });
      }
      this.load(false);
    },
    async verUbicacion(id) {
      this.loading = true;
      this.setFiltro(id);
      this.setFiltroNivel(id);
      await this.listarUbicaciones(this.$route.params.id);
      await this.listarUbicacionesEmpresa(this.$route.params.id);
      this.loading = false;
    },
    async cancelar() {
      this.resetSelectedUbicacion();
      this.resetSelectedUbicacionEmpresa();
      this.resetOptions();
      this.setPaso(0);
      this.setModal(false);
    },
    ...mapActions('ubicacion', [
      'crearUbicacion',
      'listarNivel',
      'listarUbicaciones',
      'crearUbicacionEmpresa',
      'listarUbicacionesEmpresa',
      'listarNivelActivos',
      'verUbicacionesEmpresa',
      'arbolUbicacionesEmpresa'
    ]),
    ...mapMutations('ubicacion', [
      'resetSelectedNivel',
      'resetSelectedUbicacion',
      'setFiltro',
      'setSelectedNivel',
      'setSelectedUbicacion',
      'setFiltroNivel',
      'setUbicacionEmpresa',
      'setPaso',
      'setModal',
      'setIdUbicacionParent',
      'resetSelectedUbicacionEmpresa',
      'resetOptions'
    ]),
    ...mapMutations('dashboard', [
      'load'
    ])
  },
  computed: {
    ...mapState('ubicacion', [
      'selectedNivel',
      'selectedUbicacion',
      'selectedUbicacionEmpresa',
      'niveles',
      'ubicaciones',
      'errorUbic',
      'errorNivel',
      'ubicacionEmpresa',
      'nivelesActivos',
      'id_ubicacion',
      'arbolUbicaciones',
      'ultimo_id',
      'ubicacionAsig',
      'filtro',
      'crearUbic',
      'modal',
      'ubicacionParent',
      'ubicacionPadre'
    ]),
  },
};
</script>
